module.exports = fox._r("fonts/ostrich-sans-bold.woff", __webpack_public_path__ + "_/_/_/root/fonts/1fNPEut.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/ostrich-sans-bold.woff
// module id = 157
// module chunks = 4